import type { Directive } from 'vue';

interface ElType extends HTMLElement {
  _infiniteScrollHandler?: () => void;
}

function debounce(fn: Function, delay = 200) {
  let timer: any = null;
  return function (this: any, ...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

export const infiniteScroll: Directive = {
  mounted(el: ElType, binding) {

    if (typeof binding.value !== 'function') {
      console.warn('v-infinite-scroll 需要绑定一个函数');
      return;
    }

    const handler = () => {
      const { scrollTop, clientHeight, scrollHeight } = el;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        binding.value();
      }
    };

    // 包装防抖函数
    const debounceHandler = debounce(handler, 300);

    el._infiniteScrollHandler = debounceHandler;
    el.addEventListener('scroll', debounceHandler);
  },
  unmounted(el: ElType) {
    if (el._infiniteScrollHandler) {
      el.removeEventListener('scroll', el._infiniteScrollHandler);
    }
  },
};
